module.exports = __webpack_public_path__ + "img/530.2c0dca43.gif";